<header message="{{ 'LOGIN.WELCOME' | translate:locale.language }}"></header>

<div class="occon-login-body">
  <div class="occon-login-columns animated fadeInDown">
    <div class="row white-bg occon-login-panel">
      <p-messages class="col-xs-12 mail-validation-success-info" [(value)]="infoMessages"
                  [closable]="false"></p-messages>
      <div class="login-panel-part">
        <div class="occon-login-info">
          <div class="occon-login-support">
            <h4>{{ 'LOGIN.SUPPORT' | translate:locale.language }}</h4>
            <div>
              <fa-icon icon="clock" size="4x"></fa-icon>
              <span>
                {{ 'LOGIN.OFFICE_HOURS' | translate:locale.language }}:<br>
                {{ 'LOGIN.MONDAY_TO_FRIDAY' | translate:locale.language }}
                8:00 - 17:00 CET
              </span>
            </div>
            <div>
              <fa-icon icon="at" size="4x"></fa-icon>
              <span>
                {{ 'LOGIN.MAIL' | translate:locale.language }}:<br>
                support@occon.de
              </span>
            </div>
            <div>
              <fa-icon icon="phone" size="3x"></fa-icon>
              <span>
                {{ 'LOGIN.PHONE' | translate:locale.language }}:<br>
                +49 621 5968 3262 - 20
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="login-part-separator">
        <div class="separator-left"></div>
        <div class="separator-right"></div>
        <div class="login-icon">
          <div class="outer">
            <fa-icon size="2x" icon="sign-in-alt"></fa-icon>
          </div>
        </div>
      </div>
      <div class="login-panel-part">
        <div class="ibox-content no-top-border">
          <form class="m-t" role="form">
            <div class="form-group">
              <input type="email" class="form-control" placeholder="{{ 'LOGIN.USERNAME' | translate:locale.language }}"
                     name="username"
                     [(ngModel)]="user.username" required="" [spellcheck]="false">
            </div>
            <div class="form-group">
              <input type="password" class="form-control"
                     placeholder="{{ 'LOGIN.PASSWORD' | translate:locale.language }}"
                     name="password"
                     [(ngModel)]="user.password" required="">
            </div>
            <h4 class="credentials-error" [ngStyle]="{ 'visibility': error ? 'visible' : 'hidden' }">{{ error }}</h4>
            <button [disabled]="!user.username || !user.password" (click)="logIn()"
                    class="btn btn-success block full-width m-b">Login
            </button>
            <button (click)="navigateToSSOLogin()" type="button"
                    class="btn btn-info block full-width m-b">{{ 'LOGIN.LOGIN_EXTERNAL_BUTTON' | translate:locale.language }}
            </button>

            <a (click)="openRenewalDialog()">
              <small>{{ 'LOGIN.FORGOT_PASSWORD' | translate:locale.language }}?</small>
            </a>

            <p class="text-muted text-center">
              <small>{{ 'LOGIN.NO_ACCOUNT' | translate:locale.language }}?</small>
            </p>
            <a class="btn btn-sm btn-default btn-block"
               [routerLink]="['/registration']">{{ 'LOGIN.CREATE_ACCOUNT' | translate:locale.language }}</a>
          </form>
        </div>
      </div>
    </div>
    <br>
  </div>
</div>

<footer></footer>

<p-dialog [(visible)]="showTotpDialog" styleClass="occon-modal occon-modal-totp" [resizable]="false" [modal]="true"
          appendTo="body" [closable]="false">
  <p-header>
    <span>{{'LOGIN.TOTP_DIALOG_TITLE' | translate:locale.language }}</span>
  </p-header>
  <div class="label-and-input">
    <label for="totp-code-input">{{'LOGIN.TOTP_ENTER_CODE' | translate:locale.language }}:</label><br/>
    <input *ngIf="showTotpDialog" [autoFocus]="true"
           placeholder="{{'LOGIN.TOTP_INPUT_PLACEHOLDER' | translate:locale.language }}"
           id="totp-code-input" type="text"
           [(ngModel)]="totpCode" (keyup.enter)="submitTotpCode()" autocomplete="off">
  </div>
  <p-footer>
    <button class="btn btn-default"
            (click)="showTotpDialog = false">{{'GENERAL.CANCEL' | translate:locale.language }}</button>
    <button class="btn btn-success"
            (click)="submitTotpCode()">{{ 'GENERAL.SUBMIT' | translate:locale.language }}</button>
  </p-footer>
</p-dialog>

<p-dialog [(visible)]="showPasswordDialog" styleClass="occon-modal occon-modal-sm new-tender-modal"
          [resizable]="false" [modal]="true" [dismissableMask]="true" appendTo="body">
  <p-header>
    <span>{{'LOGIN.FORGOT_PASSWORD' | translate:locale.language }}</span>
  </p-header>
  <span>{{'LOGIN.PASSWORD_RENEWAL' | translate:locale.language }}:</span>
  <input [(ngModel)]="resetPasswordUsername" (keydown.enter)="sendPasswordReset()">
  <p-footer>
    <button class="btn btn-default"
            (click)="showPasswordDialog = false">{{'GENERAL.CANCEL' | translate:locale.language }}</button>
    <button [disabled]="!resetPasswordUsername" class="btn btn-success"
            (click)="sendPasswordReset()">{{'DATA.SHEETDESIGNER.LABELS.OK' | translate:locale.language }}</button>
  </p-footer>
</p-dialog>

<p-dialog [(visible)]="showAppSelection" styleClass="occon-modal occon-modal-app-selection" [resizable]="false"
          [modal]="true" [dismissableMask]="false" appendTo="body" [closable]="false" [draggable]="false">
  <p-header>
    <span class="app-selection-dialog-header-text">U-TENDER APP SELECTION</span>
    <a class="sign-out-link" href="#" (click)="executeLogout()">
      <fa-icon icon="sign-out-alt"></fa-icon>
      {{ "GENERAL.LOGOUT" | translate:locale.language }}</a>

  </p-header>
  <div class="app-selection">
    <div class="u-tender-app" [class.inactive]="!app.active" *ngFor="let app of uTenderApps"
         (click)="selectAndLogin(app.key)">
      <div class="app-icon">
        <fa-icon size="2x" [icon]="app.icon"></fa-icon>
        <fa-icon *ngIf="!app.active" class="lock-icon" icon="lock"></fa-icon>
      </div>
      <div class="app-name">
        <span>{{ app.name }}</span>
      </div>
    </div>
  </div>
</p-dialog>






